<template>
  <div class="create_palne_wrapper">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="backComfim = true" class="nav-wrap">
        <p class="title">
          {{ isEdit ? "编辑招标计划" : "创建招标计划" }}
        </p>
        <div class="nav-right" slot="right">
          <!-- <p>开班成功后，系统将自动创建学员帐号，并分组~</p> -->
        </div>
      </yioks-page-nav>

      <div class="content-wrap">
        <vue-scroll :ops="vuescrollOpt">
          <div class="form-wrap">
            <el-form
              ref="planeForm"
              :model="formData"
              :rules="formDataRules"
              label-width="190px"
              size="medium"
              class="form-cont"
            >
              <el-form-item label="培训班等级" prop="plan_level">
                <el-select
                  v-model="formData.plan_level"
                  disabled
                  class="input-w260"
                  placeholder="请选择培训班等级"
                >
                  <el-option
                    v-for="item in highClassLevelList"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="培训班类型" prop="plan_type" class>
                <el-select
                  v-model="formData.plan_type"
                  disabled
                  class="input-w260"
                  placeholder="请选择培训班类型"
                >
                  <el-option
                    v-for="item in class_train_type_list"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="招标名称"
                prop="plan_name"
                class="test-inline"
              >
                <el-button type="primary" @click="ifNameDiaShow = true"
                  >添加名称</el-button
                >
                <span class="text_line l10">{{ formData.plan_name }}</span>
              </el-form-item>

              <el-form-item
                label="招标截止日期"
                prop="end_date"
                v-if="formData.plan_type !== 'teacher_train'"
              >
                <el-date-picker
                  type="date"
                  v-model="formData.end_date"
                  :picker-options="recommendEndDateRangeOpt"
                  :clearable="true"
                  value-format="timestamp"
                  class="input-w260"
                  placeholder="选择招标截止日期"
                ></el-date-picker>
              </el-form-item>
  
              <el-form-item label="计划开班“期数/月份”切换" class>
                <el-switch v-model="formData.time_change_way"  active-value="periods" inactive-value="month" style="margin-right:10px"  @change="changeWay"></el-switch>
              </el-form-item>
              
              <div
                class="flex-box"
                v-for="(
                  rangeItem1, rangeIndex1
                ) in formData.class_the_tender_phase"
                :key="rangeIndex1"
                v-if="formData.time_change_way==='month'"
              >
                <div class="left">
                  <el-form-item
                    :label="`招标培训班月份选择${rangeIndex1 + 1}`"
                    :error="classPhaseError"
                    :prop="`class_the_tender_phase.${rangeIndex1}.classRangeListItem`"
                    :rules="[requiredItem('培训班月份', true)]"
                  >
                    <el-date-picker
                      type="monthrange"
                      v-model="rangeItem1.classRangeListItem"
                      :picker-options="classRangeOpt"
                      :editable="false"
                      :clearable="false"
                      value-format="timestamp"
                      range-separator="至"
                      start-placeholder="开始月份"
                      end-placeholder="结束月份"
                      class="input-w360"
                    ></el-date-picker>
                  </el-form-item>
                </div>
                <div class="right">
                  <el-button
                    v-if="
                      rangeIndex1 == formData.class_the_tender_phase.length - 1
                    "
                    type="primary"
                    size="small"
                    circle
                    icon="el-icon-plus"
                    @click="handleAddPlaneDate(rangeItem1, rangeIndex1)"
                  ></el-button>
                  <el-button
                    v-if="formData.class_the_tender_phase.length > 1"
                    type="danger"
                    size="small"
                    circle
                    icon="el-icon-minus"
                    @click="handleRemovePlaneDate(rangeItem1, rangeIndex1)"
                  ></el-button>
                </div>
              </div>
  
              <div class="flex-box" v-for="(rangeItem, rangeIndex) in formData.classRangeListPeriods" :key="rangeIndex" v-if="formData.time_change_way==='periods'">
                <div class="left">
                  <el-form-item :label="`计划开班期数${rangeIndex + 1}`" >
        
                    <div class="periodsClass"  style="display:block">
                      <el-form-item label="第一阶段" label-width="100px" :prop="`classRangeListPeriods.${rangeIndex}.trainRangeOne`" :rules="[requiredItem('第一阶段', true)]">
                        <!--<el-date-picker-->
                        <!--v-model="rangeItem.start_date"-->
                        <!--type="date"-->
                        <!--@focus="datePickerOfStart(rangeItem)"-->
                        <!--:picker-options="pickerOptionsStart"-->
                        <!--placeholder="选择日期"-->
                        <!--value-format="timestamp"-->
                        <!--style="width:150px"-->
                        <!--&gt;-->
                        <!--&lt;!&ndash;pickerOptionsStart&ndash;&gt;-->
                        <!--</el-date-picker>-->
            
                        <el-date-picker
                          type="daterange"
                          :editable="false"
                          :clearable="false"
                          :picker-options="trainRangeOpt"
                          value-format="timestamp"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          v-model="rangeItem.trainRangeOne"
                          class="input-w360"
                        ></el-date-picker>
                      </el-form-item>
          
                      <el-form-item label="第二阶段" label-width="100px" :prop="`classRangeListPeriods.${rangeIndex}.trainRangeTwo`" :rules="[requiredItem('第二阶段', true)]" style="margin-top:20px">
                        <el-date-picker
                          type="daterange"
                          :editable="false"
                          :clearable="false"
                          :picker-options="trainRangeOpt"
                          value-format="timestamp"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          v-model="rangeItem.trainRangeTwo"
                          class="input-w360"
                        ></el-date-picker>
          
                      </el-form-item>
                    </div>
        
        
                    <!--<el-date-picker-->
                    <!--type="monthrange"-->
                    <!--v-model="rangeItem.classRangeListItem"-->
                    <!--:picker-options="classRangeOpt"-->
                    <!--:editable="false"-->
                    <!--:clearable="false"-->
                    <!--value-format="timestamp"-->
                    <!--range-separator="至"-->
                    <!--start-placeholder="开始月份"-->
                    <!--end-placeholder="结束月份"-->
                    <!--class="input-w360"-->
                    <!--&gt;</el-date-picker>-->
                  </el-form-item>
    
                </div>
                <div class="right">
                  <el-button v-if="rangeIndex == formData.classRangeListPeriods.length - 1" type="primary" size="small" circle icon="el-icon-plus" @click="handleAddPlanePeriods(rangeItem, rangeIndex)"></el-button>
                  <el-button v-if="formData.classRangeListPeriods.length > 1" type="danger" size="small" circle icon="el-icon-minus" @click="handleRemovePlanePeriods(rangeItem, rangeIndex)"></el-button>
                </div>
              </div>

              <el-form-item
                label="联系人"
                prop="class_the_tender_linkman"
                class="test-inline"
              >
                <el-button type="primary" @click="ifContactDiaShow = true"
                  >添加联系人</el-button
                >
                <span :class="['tip', testContact ? 'yes' : 'no']">{{
                  testContact ? "联系人添加成功" : "联系人未添加"
                }}</span>
              </el-form-item>

              <el-form-item label="说明" prop="content">
                <el-input
                  v-show="false"
                  v-model="formData.content"
                  class
                  placeholder
                ></el-input>
                <quill-editor
                  class="editor-box"
                  ref="textEditor"
                  v-model="formData.content"
                  :options="editorOption"
                ></quill-editor>
              </el-form-item>

              <el-form-item label="附件上传">
                <el-upload
                  ref="uploadFile"
                  action="/api/enroll/upload_enroll_file.json"
                  :file-list="formData.files"
                  :headers="fileUpHeaders"
                  :data="fileUpParam"
                  :before-upload="beforeUpload"
                  :on-progress="isUping"
                  :on-error="uploadError"
                  :on-success="uploadSuccess"
                  :on-remove="fileRemove"
                >
                  <el-button type="primary">点击上传</el-button>
                  <div slot="tip" class>
                    只能上传jpg/png/pdf/xlsx/xls/docx/doc文件，且文件大小不能超过200M
                  </div>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
      </div>

      <div class="post-btn">
        <el-button type="primary" @click="saveEdit">{{
          isEdit ? "编辑" : "创建"
        }}</el-button>
        <el-button type="danger" @click="backComfim = true">取消</el-button>
      </div>

      <!-- 添加培训班招标计划名称 -->
      <el-dialog
        title="添加培训班招标计划名称"
        :visible.sync="ifNameDiaShow"
        :close-on-click-modal="false"
        top="13vh"
        width="450px"
      >
        <div class="name-dialog-wrapper">
          <el-form
            ref="nameFormDom"
            :model="nameForm"
            :rules="nameFormRules"
            label-width="100px"
            size="medium"
            class="dia-form"
          >
            <el-form-item label="开启自定义" prop="isCustom" class>
              <el-switch v-model="nameForm.isCustom"></el-switch>
            </el-form-item>

            <template v-if="!nameForm.isCustom">
              <el-form-item label="年份" prop="year">
                <el-date-picker
                  v-model="nameForm.year"
                  clearable
                  :picker-options="yearOpt"
                  value-format="yyyy"
                  type="year"
                  :disabled="nameForm.isCustom"
                  class="w280"
                  placeholder="请选择年份"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="次数" prop="times" class>
                <span class="text_line left">第</span>
                <el-input-number
                  style="width: 100px"
                  v-model="nameForm.times"
                  controls-position="right"
                  :min="1"
                  :step="1"
                  step-strictly
                  :disabled="nameForm.isCustom"
                ></el-input-number>
                <span class="text_line l10">次</span>
              </el-form-item>
            </template>

            <template v-else>
              <el-form-item label="自定义名称" prop="customName">
                <el-input v-model="nameForm.customName" class="w280" @keyup.enter.native="handleNameForm(true)"></el-input>
              </el-form-item>
            </template>
          </el-form>

          <div class="footer-btns">
            <el-button type="primary" @click="handleNameForm(true)"
              >确认</el-button
            >
            <el-button type="danger" @click="handleNameForm(false)"
              >取消</el-button
            >
          </div>
        </div>
      </el-dialog>

      <!-- 添加联系人 -->
      <el-dialog
        @open="contactDiaOpen"
        :visible.sync="ifContactDiaShow"
        :close-on-click-modal="false"
        top="13vh"
        width="855px"
        class="yi-dialog-root scroll-dialog"
      >
        <div class="slot-dialog-header" slot="title">
          <span class="title">添加联系人</span>
        </div>
        <div class="dialog-content contact-dia-content">
          <vue-scroll :ops="disScrollOpt">
            <div class="dia-scroll-content">
              <el-form
                :model="contactData"
                ref="contactDialogForm"
                label-width="60px"
                size="medium"
                class="dia-form"
              >
                <div
                  class="form-oneline-wrap clearfix"
                  v-for="(contact, index) in contactData.contactInfoList"
                  :key="contact.id"
                >
                  <el-form-item
                    label="姓名"
                    :prop="'contactInfoList.' + index + '.name'"
                    :rules="{
                      required: true,
                      message: `不能为空`,
                      trigger: `blur`,
                    }"
                    class="dia-input-wrap contact-name-wrap"
                  >
                    <el-input
                      placeholder="请输入联系人姓名"
                      v-model="contact.name"
                      class="dia-input-w160"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="电话"
                    :prop="'contactInfoList.' + index + '.mobile_phone'"
                    :rules="{
                      required: true,
                      validator: (rule, value, callback) => {
                        validatePhone(rule, value, callback);
                      },
                      trigger: `blur`,
                    }"
                    class="dia-input-wrap contact-phone-wrap"
                  >
                    <el-input
                      placeholder="请输入联系人手机号"
                      v-model="contact.mobile_phone"
                      class="dia-input-w160"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="邮箱"
                    :prop="'contactInfoList.' + index + '.email'"
                    :rules="{
                      required: false,
                      validator: (rule, value, callback) => {
                        validateEmail(rule, value, callback);
                      },
                      trigger: `blur`,
                    }"
                    class="dia-input-wrap contact-email-wrap"
                  >
                    <el-input
                      placeholder="请输入联系人邮箱"
                      v-model="contact.email"
                      class="dia-input-w160"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="单位"
                    :prop="'contactInfoList.' + index + '.work'"
                    :rules="{}"
                    class="dia-input-wrap contact-email-wrap"
                  >
                    <el-input
                      placeholder="请输入联系人邮箱"
                      v-model="contact.work"
                      class="dia-input-w160"
                    ></el-input>
                  </el-form-item>
                  <el-button
                    class="form-oneline-btn"
                    size="medium"
                    type="danger"
                    v-if="index > 0"
                    @click="delContact(index)"
                    >删除</el-button
                  >
                  <el-button
                    v-else
                    class="form-oneline-btn"
                    size="medium"
                    type="primary"
                    @click="addContact"
                    >添加</el-button
                  >
                </div>
              </el-form>
            </div>
          </vue-scroll>
        </div>
        <div class="footer-btn" slot="footer">
          <div class="btns">
            <el-button type="primary" @click="saveContactList">保存</el-button>
            <el-button type="danger" @click="ifContactDiaShow = false"
              >取消</el-button
            >
          </div>
        </div>
      </el-dialog>

      <!-- 提交确认 -->
      <y-tips
        :showTips="isConfirm"
        :tips="confirmMsg"
        :loading="confirmLoading"
        @hideTips="handleConfirm"
      ></y-tips>
      <!-- 返回确认 -->
      <y-tips
        :showTips="backComfim"
        :tips="'确定放弃修改并返回吗？'"
        @hideTips="backComfimDialog"
      ></y-tips>
    </div>
  </div>
</template>

<script>
import createScrollOpt from "@/assets/js/vuescrollOption";
import {
  classLevelListForCoachAndGoalkepper,
  highClassLevelList,
  class_train_type_list,
} from "@/assets/js/select";
import { classTypeFilterWithoutFlag } from "@/assets/js/yioksFilters";
import {
  signUpLinksForPlan,
  createHeighClassPlane,
  putHeighClassPlane,
  viewHeighClassPlane,
} from "@/api/system_manager/api";
import commonFun from "@/assets/js/yioks";
const { mobile_phone, email } = commonFun;
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import { storageData } from "@/assets/js/storage";

export default {
  data() {
    const editorOption = {
      placeholder: "请填写说明",
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike", "link", "blockquote"],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ color: [] }, { background: [] }],
          [
            { size: ["small", false, "large", "huge"] },
            { header: [1, 2, 3, 4, 5, 6, false] },
          ],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: [] }],
          ["clean"],
        ],
      },
    };
    const validatePhone = (rule, value, callback) => {
      if (value !== "") {
        callback();
      } else {
        callback(new Error("请输入电话"));
      }
    };

    const validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback();
        return;
      }
      if (email(value)) {
        callback();
      } else {
        callback(new Error("请输入格式正确的邮箱"));
      }
    };
    return {
      backComfim: false,
      ifNameDiaShow: false, // 招标名字弹窗
      ifContactDiaShow: false, // 联系人弹窗
      vuescrollOpt: createScrollOpt(),
      disScrollOpt: createScrollOpt(true),
      highClassLevelList: classLevelListForCoachAndGoalkepper,
      class_train_type_list,
      fileUpHeaders: {
        "X-Token": storageData.getToken(),
        "X-UserType": storageData.getUserType(),
      },
      fileUpParam: {},
      fileLimitNum: 3,
      formData: {
        plan_level: "",
        plan_type: "",
        plan_name: "",
        end_date: "",
        content: "",
        class_the_tender_linkman: "", // 联系人
        class_the_tender_phase: [{
            classRangeListItem: [],
          }], // 计划开班时间
        classRangeListPeriods: [{
          trainRangeOne:[],
          trainRangeTwo:[],
        }], // 计划开办期数冗余字段；
        files: [],
        time_change_way: "periods",
      },
      formDataRules: {
        plan_level: [requiredItem("培训班等级")],
        plan_type: [requiredItem("培训班类型")],
        plan_name: [requiredItem("招标名称")],
        end_date: [requiredItem("截止日期")],
        class_the_tender_linkman: [requiredItem("联系人")],
        content: [requiredItem("说明")],
      },
      nameForm: {
        isCustom: false,
        year: "",
        customName: "",
        times: 0,
      },
      nameFormRules: {
        year: [requiredItem("年份")],
        times: [requiredItem("次数")],
        customName: [requiredItem("名称")],
      },
      editorOption, // 富文本
      testContact: false, // 联系人获取标记
      contactData: {
        contactInfoList: [{ name: "", mobile_phone: "", email: "", id: 1 }],
      }, // 联系人列表
      validatePhone,
      validateEmail,
      isConfirm: false,
      confirmMsg: "",
      confirmLoading: false,
      classPhaseError: '',
    };
  },

  components: {
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
  },

  computed: {
    // uuid: plan_uuid,
    //       isEdit: 1
    trainRangeOpt() {
      return {
        disabledDate: time => {
          return time.getTime() < new Date().setHours(0, 0, 0, 0);
        }
      };
    },
    plan_uuid() {
      const { uuid } = this.$route.query;
      return uuid;
    },
    isEdit() {
      const { isEdit } = this.$route.query;
      return isEdit && isEdit == 1 ? true : false;
    },
    classTrainType() {
      const { classTrainType } = this.$route.query;
      return classTrainType;
    },

    classLevel() {
      const { classLevel } = this.$route.query;
      return classLevel;
    },

    recommendEndDateRangeOpt() {
      return {
        disabledDate: (time) => {
          return time.getTime() < new Date();
        },
      };
    },

    yearOpt() {
      return {
        disabledDate: (time) => {
          return time.getFullYear() < new Date().getFullYear();
        },
      };
    },
    classRangeOpt() {
      return {
        disabledDate: (time) => {
          let year = new Date().getFullYear();
          let month = new Date().getMonth() + 1;
          return time < new Date(year + "/" + month + "/1");
        },
      };
    },
    backUrl() {
      const { backUrl } = this.$route.query;
      return backUrl ? JSON.parse(backUrl) : '';
    },
  },

  created() {
    this.setFormData(); // 填充表单基础数据（编辑/创建）
  },

  watch: {
    "formData.content": {
      handler(val) {
        if (val) {
          this.$refs.planeForm.clearValidate(["content"]);
        }
      },
    },
  },

  methods: {
    requiredItem,
    changeWay(){
      this.formData.class_the_tender_phase=[{
          classRangeListItem: [],
        }]
       //计划开班时间
      this.formData.classRangeListPeriods=[{
        trainRangeOne:[],
        trainRangeTwo:[],
      }] // 计划开办期数冗余字段；
    },
    goBack() {
      this.$router.push("heigh_class_plane");
    },
    // 创建招标
    saveEdit() {
      this.$refs.planeForm.validate((valid) => {
        if (valid) {
          // 检查是否存在有相同计划开班月份
          const classTenderPhaseValidator = this.validatorForClassTenderPhase();
          
          if (classTenderPhaseValidator) {
            this.confirmMsg = this.isEdit
              ? "确认修改此培训班招标计划？"
              : "确认创建此培训班招标计划？";
            this.isConfirm = true;
          }
        }
      });
    },

    validatorForClassTenderPhase() {
      if(this.classPhaseError) this.classPhaseError = '';
      const { class_the_tender_phase , classRangeListPeriods,time_change_way} = this.formData;
      if(time_change_way === 'month'){
        if (class_the_tender_phase.length) {
          const momentJS = require("moment");
          let allLabelName = [];
          let status = true;
          class_the_tender_phase.forEach((item) => {
            const [start_date, end_date] = item.classRangeListItem;
            const labelName = `${momentJS(start_date).format(
              "yyyy-MM"
            )} 至 ${momentJS(end_date).format("yyyy-MM")}`;
            if (allLabelName.includes(labelName)) {
              this.classPhaseError = '存在重复计划开班时间';
              this.$message.error("计划开班月份有重复选项，请检查后重新提交");
              status = false;
            } else {
              allLabelName.push(labelName);
            }
            if(item.classRangeListItem.length === 0){
              this.$message.error("计划开班月份选择有误，请检查后重新提交");
              status = false;
            }
          });
          return status
        } else {
          // console.error("计划开班时间列表 class_the_tender_phase 有问题咯");
          return false;
        }
      }else{
        return true
      }
      
    },

    // 确认创建
    handleConfirm(bool, sure) {
      if (sure) {
        const {
          class_the_tender_linkman,
          class_the_tender_phase,
          classRangeListPeriods,
          files,
          ...other
        } = this.formData;
        let plane_class_phase = [];
        let plane_class_phase_Periods = [];
        if (this.formData.time_change_way ==='month') {
          if (class_the_tender_phase.length) {
            const momentJS = require("moment");
            let allLabelName = [];
            class_the_tender_phase.forEach((item) => {
              const [start_date, end_date] = item.classRangeListItem;
              const labelName = `${momentJS(start_date).format(
                "yyyy-MM"
              )} 至 ${momentJS(end_date).format("yyyy-MM")}`;
              if (allLabelName.includes(labelName)) {
                this.$message.warn("计划开班月份有重复选项，请检查后重新提交");
                return;
              } else {
                allLabelName.push(labelName);
                plane_class_phase.push({
                  start_date,
                  end_date,
                  phase: labelName,
                });
              }
            });
          } else {
            console.error("计划开班时间列表 class_the_tender_phase 有问题咯");
          }
        }else{
          if(classRangeListPeriods.length) {
            const momentJS = require("moment");
            classRangeListPeriods.forEach(item => {
              const { trainRangeOne, trainRangeTwo } = item;
              const start_date = trainRangeOne[0];
              const end_date = trainRangeOne[1];
              const start_date_two = trainRangeTwo[0];
              const end_date_two = trainRangeTwo[1];
              const labelName = `${momentJS(start_date).format(
                "yyyy-MM-DD"
              )} 至 ${momentJS(end_date).format("yyyy-MM-DD")}`;
              const labelNameTwo = `${momentJS(start_date_two).format(
                "yyyy-MM-DD"
              )} 至 ${momentJS(end_date_two).format("yyyy-MM-DD")}`;
              plane_class_phase.push({
                start_date:start_date,
                end_date:end_date,
                start_date_two:start_date_two,
                end_date_two:end_date_two,
                phase: labelName,
                phase_two: labelNameTwo,
              })
            });
          } else {
            console.error('计划开班期数 时间段有问题咯')
          }
        }
        let submitData = {
          ...other,
          class_the_tender_linkman: JSON.stringify(class_the_tender_linkman),
          class_the_tender_phase: JSON.stringify(plane_class_phase),
          class_the_tender_document: JSON.stringify(
            files.map((item) => ({
              document_url: item.url,
              document_name: item.name,
              document_id: item.document_id || "",
            }))
          ),
        };
        
        let requestName = null;
        if (this.isEdit) {
          requestName = putHeighClassPlane;
        } else {
          requestName = createHeighClassPlane;
        }
        requestName(submitData)
          .then(({ data }) => {
            if (data.status === 0) {
              this.$message.success("创建成功！");
              this.$router.push({
                path: this.backUrl || "heigh_class_plane",
                query: {
                  uuid: this.plan_uuid,
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          })
          .catch((err) => {
            console.error("err", err);
          });
      }
      this.isConfirm = bool;
    },

    // 填充数据
    setFormData() {
      if (this.isEdit) {
        this.setDataForEdit();
      } else {
        if (this.classTrainType)
          this.$set(this.formData, "plan_type", this.classTrainType);
        if (this.classLevel)
          this.$set(this.formData, "plan_level", this.classLevel);

        this.getClassLinks(); // 填充联系人
      }
    },

    // 编辑模式 填充数据
    setDataForEdit() {
      viewHeighClassPlane(this.plan_uuid)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          const { classPhase, documentDate, linkmenData, planInfo } =
            data.result;
          //  填充联系人
          if (linkmenData && linkmenData.length) {
            this.$set(this.contactData, "contactInfoList", linkmenData);
            this.testContact = true;
            this.formData.class_the_tender_linkman = linkmenData;
          } else {
            this.getClassLinks(); // 获取联系人
          }

          // 填充附件数据
          if (documentDate && documentDate.length) {
            const files = documentDate.map((item) => {
              const { document_title, document_address, plan_id, document_id } =
                item;
              return {
                name: document_title,
                url: document_address,
                id: plan_id,
                document_id: document_id,
              };
            });
            this.formData.files = files;
          }

          // 填充计划开办日期
          if (classPhase && classPhase.length) {
            const class_the_tender_phase = classPhase.map((item) => {
              const { end_date, start_date } = item;
              return {
                classRangeListItem:[start_date, end_date]
              };
            });
            this.$set(
              this.formData,
              "class_the_tender_phase",
              class_the_tender_phase
            );
            const class_the_tender_phase_periods = classPhase.map((item) => {
              const { end_date, start_date, start_date_two, end_date_two } = item;
              return {
                trainRangeOne:[start_date, end_date],
                trainRangeTwo:[start_date_two, end_date_two],
              }
            });
            
            this.$set(
              this.formData,
              "classRangeListPeriods",
              class_the_tender_phase_periods
            );
          }
          // 填充基本招标基本信息
          const {
            plan_level,
            plan_type,
            plan_name,
            end_date,
            content,
            plan_uuid,
            time_change_way,
          } = planInfo;
          this.formData = Object.assign({}, this.formData, {
            plan_level,
            plan_type,
            plan_name,
            end_date,
            content,
            plan_uuid,
            time_change_way,
          });
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    // 设置招标名称
    handleNameForm(actionStatus) {
      if (actionStatus) {
        this.$refs.nameFormDom.validate((valid) => {
          if (valid) {
            const { isCustom, year, customName, times } = this.nameForm;
            if (isCustom) {
              this.$set(this.formData, "plan_name", customName);
            } else {
              let formateName = this.getPlaneName(year, times);
              this.$set(this.formData, "plan_name", formateName);
              this.$refs.planeForm.clearValidate(["plan_name"]);
            }
            this.ifNameDiaShow = false;
          }
        });
      } else {
        this.ifNameDiaShow = false;
      }
    },

    // 格式化招标名称
    getPlaneName(year, times) {
      const class_level = this.classLevel || this.formData.plan_level || "B";
      const class_type =
        this.classTrainType ||
        this.formData.plan_type ||
        new Date().getFullYear();
      // 暂时方案，待修改
      let str = `${year}年亚足联-中国足协第${times}次${class_level}级教练员培训班举办地招标报名`;
      return str;
    },

    // 获取默认联系人列表
    getClassLinks() {
      signUpLinksForPlan({})
        .then(
          ({
            data: {
              status,
              result: { linkman },
            },
          }) => {
            if (status === 0) {
              if (linkman.length > 0) {
                this.contactData.contactInfoList = linkman.map(
                  ({ email, mobile_phone, name, tc_id }, i) => ({
                    name,
                    email,
                    mobile_phone,
                    id: i + 1,
                  })
                );
                this.testContact = true;
              } else {
                this.testContact = false;
              }
              this.formData.class_the_tender_linkman = JSON.parse(
                JSON.stringify(this.contactData.contactInfoList)
              );
            }
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },
    // 联系人弹窗信息
    contactDiaOpen() {
      this.$nextTick(() => {
        this.$refs["contactDialogForm"].clearValidate();
      });
      const class_the_tender_linkman = JSON.parse(
        JSON.stringify(this.formData.class_the_tender_linkman)
      );
      this.$set(this.contactData, "contactInfoList", class_the_tender_linkman);
    },
    // 删除联系人
    delContact(index) {
      this.contactData.contactInfoList.splice(index, 1);
    },
    // 添加联系人
    addContact() {
      this.contactData.contactInfoList.push({
        name: "",
        mobile_phone: "",
        email: "",
        work: "",
        id: this.contactData.contactInfoList.length + 1,
      });
    },

    // 返回确认；
    backComfimDialog(bool, sure) {
      this.backComfim = bool;
      if (sure) {
        this.$router.go(-1);
      }
    },

    // 保存联系人弹窗
    saveContactList() {
      this.$refs["contactDialogForm"].validate((valid) => {
        const contactData = JSON.parse(JSON.stringify(this.contactData));
        if (valid) {
          this.$set(
            this.formData,
            "class_the_tender_linkman",
            contactData.contactInfoList
          );
          this.ifContactDiaShow = false;
          this.testContact = true;
        }
      });
    },

    // 添加计划开班月份
    handleAddPlaneDate(item, index) {
      if(this.classPhaseError) this.classPhaseError = '';
      let { class_the_tender_phase } = this.formData;
      // if(class_the_tender_phase.length >= 5) return;  // 无上限
      class_the_tender_phase.push({
        classRangeListItem: [],
      });
    },

    // 删除计划开班月份
    handleRemovePlaneDate(item, index) {
      if(this.classPhaseError) this.classPhaseError = '';
      let { class_the_tender_phase } = this.formData;
      if (class_the_tender_phase.length == 1) return; // 至少保留一个
      class_the_tender_phase.splice(index, 1);
    },
    // 添加计划开班月份
    handleAddPlanePeriods(item, index) {
      let { classRangeListPeriods } = this.formData;
      // if(classRangeList.length >= 5) return;  // 无上限
      classRangeListPeriods.push({
        trainRangeOne:[],
        trainRangeTwo:[],
      });
    },
    // 删除计划开班月份
    handleRemovePlanePeriods(item, index) {
      let { classRangeListPeriods } = this.formData;
      if(classRangeListPeriods.length == 1) return;  // 至少保留一个
      classRangeListPeriods.splice(index,1)
    },
    isUping() {
      this.submitDisabled = true;
    },
    uploadError() {
      this.submitDisabled = false;
    },
    uploadSuccess(res) {
      this.submitDisabled = false;
      if (Number(res.status) === 0) {
        this.formData.files.push({
          url: res.result.document_url,
          name: res.result.document_name,
        });
      } else {
        this.$nextTick(() => {});
        this.$message.error(res.msg);
      }
    },
    fileExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 ${this.fileLimitNum} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    fileRemove(file, fileList) {
      this.formData.files = fileList;
    },
    beforeUpload(file) {
      if (file.size > 200 * 1024 * 1024) {
        this.$message.error("文件大小不能超过200M!");
        return false;
      }
      if (!/^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i.test(file.name)) {
        this.$message.error("请上传 jpg png pdf xlsx xls docx doc格式的文件!");
        return false;
      }
      let param = {
        document: file,
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.fileUpParam, key, param[key]);
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/linDialog'
$page_main_height = 680px
.create_palne_wrapper
  zuxie-page-root()
  .text_line
    margin-right 10px
    font-size $font_size_medium
  .footer-btn
    .btns
      display flex
      justify-content center
      color $color_white
      .btn
        padding 10px 25px
        margin 0 10px
        border-radius 4px
        cursor pointer
        user-select none
      .save
        background-color $color_suc
      .cancel
        background-color $color_err
.main-content-wrap
  color $color_white
  // .nav-wrap
  // margin-bottom 20px !important
  .title
    line-height 1
    font-size $font_size_big
  .nav-right
    color $color_err
    margin-right 12px
.content-wrap
  display block
  width 100%
  height 600px
  padding 15px 0 10px
  position relative
  background-color $block_bg_color_base
  margin-bottom 15px
  margin-top 20px
.post-btn
  width 35%
  margin 0 auto
  display flex
  justify-content space-around
.l10
  margin-left 10px
.w280
  width 280px
.footer-btns
  width 35%
  margin 0 auto
  display flex
  justify-content space-around
.dialog-content
  .dia-form
    .form-oneline-wrap
      border-bottom 1px solid #ccc
      padding-top 20px
      position relative
      .dia-input-wrap
        float left
        margin-bottom 20px
      .dia-input-w180
        width 180px
      .dia-input-w160
        width 120px
      .dia-input-w100
        width 100px
      .form-oneline-btn
        float left
        margin-left 15px
    .w100
      width 100%
.flex-box
  display flex
  justify-content flex-start
  .right
    margin-left 20px
    box-sizing border-box
</style>

<style lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/linDialog'
.content-wrap
  display block
  width 100%
  height 600px
  padding 15px 0 10px
  position relative
  background-color $block_bg_color_base
  margin-bottom 15px
  .form-wrap
    display block
    width 890px
    padding-right 35px
    padding-left 20px
    .form-cont
      padding-top 8px
      color #fff
      .el-form-item
        .editor-box
          background-color #fff
          color #333
          line-height 1
          word-break break-all
          word-wrap break-word
          .ql-toolbar.ql-snow .ql-formats
            margin-right 10px
          .ql-container
            min-height 150px
      .el-form-item__label
        color $color_white
        font-size 16px
      .el-input__inner, .el-textarea__inner
        // border-radius 0
      .el-input.is-disabled .el-input__icon
        color #666
      .el-form-item.is-required .el-form-item__label:before
        color inherit
      .el-input.is-disabled .el-input__inner
        input-disabled()
        &::-webkit-input-placeholder, &:-moz-placeholder, &::-moz-placeholder, &:-ms-input-placeholder
          color #333333
      select
        outline none
        &[disabled]
          input-disabled()
      .limit_switch
        margin-right 10px
      .input-w200
        width 200px
      .input-w360
        width 360px
      .input-w260
        width 260px
      .date-form-item
        width 260px
        float left
      .date-form-text
        text-align center
        float left
        margin 0 8px
      .set-sel
        display block
        height 36px
        border 1px solid #dcdfe6
        border-radius 4px
        color #606266
      .cost-text
        display inline-block
        margin-left 10px
        font-size 16px
      .test-inline
        .tip
          display inline-block
          font-size $font_size_base
          margin-left 15px
        .yes
          color $color_suc
        .no
          color $color_err
        .el-radio__label
          color $color_white
        .is-checked .el-radio__label
          color $color_suc
      .form-item-nomb
        margin-bottom 0
        .input-item-hasmb
          margin-bottom 22px
        .button-hasmb
          margin-bottom 15px
      .el-progress__text, .el-upload-list__item-name
        white-space normal
        color #fff
      .el-upload-list__item-name
        [class^='el-icon']
          color #fff
</style>
